import { render, staticRenderFns } from "./GmailCard.vue?vue&type=template&id=48f48d95"
import script from "./GmailCard.vue?vue&type=script&lang=js"
export * from "./GmailCard.vue?vue&type=script&lang=js"
import style0 from "./GmailCard.vue?vue&type=style&index=0&id=48f48d95&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports